import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your translation files
import enTranslation from "./en/en.json";
import frTranslation from "./fr/fr.json";

// Get initial language from localStorage or default to "en"
const getInitialLanguage = (): string => {
  if (typeof window !== "undefined") {
    const storedLang = localStorage.getItem("lang");
    if (storedLang === "en" || storedLang === "fr") {
      return storedLang;
    }
  }
  return "en";
};

i18n
  .use(Backend)
  .use(LanguageDetector) // Automatically detect user language
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    fallbackLng: "en",
    lng: getInitialLanguage(), // Initialize with language from localStorage
    debug: false,
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order in which language is detected
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],

      // Keys or params to lookup language from
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "lang",
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

      // Cache user language on
      caches: ["localStorage", "cookie"],

      // Optional expire and domain for set cookie
      cookieMinutes: 10,
      cookieDomain: "myDomain",
    },
    ns: ["translation"],
    defaultNS: "translation",
  });

export default i18n;
